export default __webpack_public_path__ + "static/media/photo--sm--58.2684b0ad.jpg";